<ng-container [formGroup]="form">

    <div class="container text-center" formGroupName="referralInfo">

        <h2>How did you hear about Perlas Insurance Services?</h2>
        <div class="mb-3">
            <input type="text" formControlName="referralSource" class="form-control centered-input mx-auto" placeholder="e.g., Website, conference, advertisement, referrals, etc.">
        </div>

        <h2>Are you in contact with a Perlas agent?</h2>
        <div class="mb-3">
            <select formControlName="hasAgentContact" class="form-control centered-input mx-auto">
                <option value=""></option>
                <option value="Yes">Yes</option>
                <option value="No">No</option>
            </select>
        </div>

        <div *ngIf="showAgentNameField">
            <h2>Please provide the agent's name</h2>
            <div class="mb-3">
                <input type="text" formControlName="agentName" class="form-control centered-input mx-auto" placeholder="Agent's name">
            </div>
        </div>

        <div *ngIf="inDev">
            <h2>Form Page Values</h2>
            <div>{{form}}</div>
            <div *ngIf="form.get('referralInfo')?.valueChanges| async as values">
                <div>Values: {{ values | json }}</div>
            </div>
            <div> Valid: {{form.get('referralInfo')?.valid}}</div>
        </div>
    </div>
</ng-container>
